// const baseurl="http://localhost:8000"
const baseurl="https://q4h2g3nsue.execute-api.ap-south-1.amazonaws.com/prod"

export {baseurl}